// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"87":"e313e5f1","121":"180cc408","126":"e8a854b2","163":"2047336d","251":"a57c10ef","420":"1531bbea","460":"649e2c7b","571":"d96889a4","606":"8b58d67e","693":"8add2873","767":"de4124db","848":"12ae6b60","916":"31f873b7"}[chunkId] + ".chunk.js";
};